<template>
    <div>
        <v-alert type="warning" prominent class="waec-service-alert mx-4 mt-4 mb-0">
            <strong>WAEC verification is temporarily on pause.</strong>
            This is due to an upstream service disruption. You can still proceed with providing your details and you
            will be verified as soon as the service is up.
        </v-alert>
        <component :is="entryComponent" @success="$emit('success')" @back="$emit('back')"></component>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import ScratchCard from "@/application/components/ScratchCard";
import ScratchCardManual from "@/application/components/ScratchCardManual";
import {
    hasPendingPurchaseScratchCardSSCE
} from "@/application/lib/scratchCardEntry";

export default {
    name: "ScratchCardEntry",
    components: { ScratchCard, ScratchCardManual },

    computed: {
        ...mapGetters(["getSSCEDetails", "getUser"]),

        automaticPurchasesEnabled() {
            return (this.getUser?.admission?.applicationType?.autoScratchCards?.length ?? 0) > 0
        },

        entryComponent() {
            return hasPendingPurchaseScratchCardSSCE(this.getSSCEDetails, this.automaticPurchasesEnabled)
                ? "scratch-card"
                : "scratch-card-manual"
        }
    }
}
</script>
